import { ExpandGuide } from './controls/buttons';
import React, { Fragment } from 'react';

import { ChannelOverlayContainer } from '../containers/ChannelOverlay';
import { DesktopOnly } from 'app-modules/application/components/MediaTargets';
import PropTypes from 'prop-types';
import { VODOverlayContainer } from '../containers/VODOverlay';
import { ViralOverlayContainer } from '../containers/ViralOverlay';
import { constants } from 'app-webtech-core';
import styled from 'styled-components';
import { withNamespaces } from 'react-i18next';
import { withPlayer } from './PlayerContext';

const Wrapper = styled.div`
  display: flex;
  color: #ffffff;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 3;
  cursor: ${(props) => (props.showCursor ? 'inherit' : 'none')};
`;

const ExpandButton = styled.div`
  font-family: 'Pluto Sans SemiBold';
  font-size: 16px;
  height: 40px;
  min-width: 120px;
  margin: ${(props) => (props.isEmbed ? '0 auto' : '')};
  width: ${(props) => (props.isEmbed ? '140px' : '')};
  background: #fff;
  position: ${(props) => (props.isEmbed ? 'relative' : 'fixed')};
  pointer-events: all;
  cursor: pointer;
  bottom: ${(props) => (props.isEmbed ? '60px' : '40px')};
  z-index: 6;
  right: ${(props) => (props.isEmbed ? '10px' : '40px')};
  border-radius: 20px;
  color: #000;
  text-align: center;
  box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.8);
  :hover {
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 1);
  }
  span {
    height: 20px;
    width: ${(props) => (props.isVod ? '65px' : 'auto')};
    margin-left: 7px;
    padding-left: 4px;
    vertical-align: super;
    display: inline-block;
    white-space: nowrap;
  }
  // for Homepage L1 player
  @media (max-width: 160px) {
    display: none;
  }
`;

class PlayerOverlayComponent extends React.Component {
  static propTypes = {
    hideTimeout: PropTypes.number,
    player: PropTypes.shape({
      kind: PropTypes.string,
      overlayFrozen: PropTypes.bool,
    }).isRequired,
    playerIsFullscreen: PropTypes.bool.isRequired,
    isVod: PropTypes.bool.isRequired,
    isEmbed: PropTypes.bool.isRequired,
    exitFullscreen: PropTypes.func.isRequired,
    onCCSubmenuOpen: PropTypes.func.isRequired,
    onCCOverlayClick: PropTypes.func.isRequired,
    onCCSetIndex: PropTypes.func.isRequired,
    onCCMenuOpen: PropTypes.func.isRequired,
    onCCMenuClose: PropTypes.func.isRequired,
    isCCMenuOpen: PropTypes.bool.isRequired,
    currentCCMenu: PropTypes.instanceOf(Array).isRequired,
    currentCCMenuName: PropTypes.string.isRequired,
    ccMenuSelectedIndexes: PropTypes.instanceOf(Array).isRequired,
    isMobile: PropTypes.bool.isRequired,
    internalFullscreen: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    hideTimeout: 5000,
  };

  state = {
    isVisible: false,
    showCursor: true,
    ccTriggeredOnPageLoad: false,
  };

  componentWillReceiveProps(nextProps) {
    // const overlayFrozenChanged = this.props.player.overlayFrozen !== nextProps.player.overlayFrozen;

    // if (overlayFrozenChanged) {
    //   this.setState({ frozen: nextProps.player.overlayFrozen });
    //   if (nextProps.player.overlayFrozen && !this.state.isVisible) {
    //     this.showOverlay();
    //   } else if (this.state.isVisible) {
    //     this.hideOverlay(nextProps.player.overlayFrozen);
    //   }
    // }

    const menuShowChanged = this.props.isCCMenuOpen !== nextProps.isCCMenuOpen;

    // This checks to see if the CC Settings Menu is open to determine if the overlay will be frozen
    if (menuShowChanged) {
      this.setState({ frozen: nextProps.isCCMenuOpen });
      if (nextProps.isCCMenuOpen && !this.state.isVisible) {
        this.showOverlay();
      } else if (this.state.isVisible) {
        this.hideOverlay(nextProps.isCCMenuOpen);
      }
    }
  }

  componentWillUnmount() {
    clearTimeout(this.hideTimeout);
  }

  // "resetCCMenu" will be called only on last user click on ccMenu before timeout
  // (30 secs) and only if ccMenu is frozen and Overlay is visible. (W50-1137)
  resetCCMenu = (id) => {
    const { frozen, isVisible, uid } = this.state;
    if (frozen && isVisible && uid === id) {
      this.props.onCCOverlayClick();
    }
  };

  onClick = (event) => {
    const uid = Math.random().toString(36).substring(2, 10);
    this.setState({ uid });
    setTimeout(() => {
      this.resetCCMenu(uid);
    }, 30000);

    if (!this.state.isVisible) {
      this.showOverlay();
    }
  };

  onFocus = () => {
    if (this.props.isMobile) {
      return;
    }
    if (!this.state.isVisible) {
      this.showOverlay();
    }
  };

  onMouseMove = () => {
    if (this.props.isMobile) {
      return;
    }
    if (!this.state.isVisible) {
      this.showOverlay();
    }
    if (!this.state.showCursor) {
      this.showCursor();
    }
  };

  onMouseLeave = () => {
    if (this.state.isVisible) {
      this.onHideOverlay();
    }
  };

  onHideOverlay() {
    this.hideOverlay(this.state.frozen);
  }

  exitFullScreen = () => {
    this.props.exitFullscreen();
    this.props.exitFullscreenSplashPage();
  };

  hideTimeout = null;

  hideOverlay(frozen) {
    // Changed this function in case the state does not change in time for
    // the componentWillReceiveProps function
    if (!frozen) {
      this.setState({ isVisible: false });
      clearTimeout(this.hideTimeout);
    }
  }

  showCursor = () => {
    this.setState({ showCursor: true });
  };

  hideCursor = () => {
    this.setState({ showCursor: false });
  };

  showOverlay() {
    this.setState({ isVisible: true });

    clearTimeout(this.hideTimeout);

    this.hideTimeout = setTimeout(() => {
      if (this.props.player.overlayFrozen) {
        this.setState({ frozen: true });
      } else {
        this.onHideOverlay();
        this.hideCursor();
      }
    }, this.props.hideTimeout);
  }

  setCcTriggeredOnPageLoad = () => {
    this.setState({ ccTriggeredOnPageLoad: true });
  };

  render() {
    const {
      player,
      isVod,
      isEmbed,
      playerIsFullscreen,
      isCCMenuOpen,
      ccMenuSelectedIndexes,
      onCCSubmenuOpen,
      onCCSetIndex,
      onCCMenuOpen,
      onCCMenuClose,
      internalFullscreen,
      currentCCMenu,
      currentCCMenuName,
      isMobile,
      isAndroid,
      isFullscreenSplashPage,
      exitFullscreenSplashPage,
      t,
    } = this.props;

    let Overlay;
    if (player.kind) {
      if (player.kind === constants.player.PLAYER_CONTENT_KIND.LINEAR_CHANNEL) {
        Overlay = ChannelOverlayContainer;
      } else if (player.kind === constants.player.PLAYER_CONTENT_KIND.VOD) {
        Overlay = VODOverlayContainer;
      } else if (player.kind === constants.player.PLAYER_CONTENT_KIND.VIRAL) {
        Overlay = ViralOverlayContainer;
      }
    }

    if (Overlay) {
      return (
        <Fragment>
          <Wrapper
            onClickCapture={this.onClick}
            onFocus={this.onFocus}
            onMouseMove={this.onMouseMove}
            onMouseLeave={this.onMouseLeave}
            showCursor={this.state.showCursor}
          >
            <Overlay
              isAndroid={isAndroid}
              isFullscreen={player.isFullscreen}
              isVisible={this.state.isVisible}
              playerIsFullscreen={playerIsFullscreen}
              onCCSubmenuOpen={onCCSubmenuOpen}
              onCCMenuOpen={onCCMenuOpen}
              onCCMenuClose={onCCMenuClose}
              onCCSetIndex={onCCSetIndex}
              isCCMenuOpen={isCCMenuOpen}
              currentCCMenu={currentCCMenu}
              currentCCMenuName={currentCCMenuName}
              ccMenuSelectedIndexes={ccMenuSelectedIndexes}
              isMobile={isMobile}
              isEmbed={isEmbed}
              internalFullscreen={internalFullscreen}
              isFullscreenSplashPage={isFullscreenSplashPage}
              exitFullscreenSplashPage={exitFullscreenSplashPage}
              ccTriggeredOnPageLoad={this.state.ccTriggeredOnPageLoad}
              setCcTriggeredOnPageLoad={this.setCcTriggeredOnPageLoad}
            />
          </Wrapper>
          <DesktopOnly>
            {playerIsFullscreen && !player.isFullscreen && !isEmbed && !isFullscreenSplashPage && (
              <ExpandButton onClick={this.exitFullScreen} isEmbed={isEmbed}>
                {isVod ? (
                  <span>{t('expand_popup_window')}</span>
                ) : (
                  <span>{t('show_guide_popup_window', 'Show guide')}</span>
                )}
                <ExpandGuide />
              </ExpandButton>
            )}
          </DesktopOnly>
        </Fragment>
      );
    }

    return null;
  }
}

export const PlayerOverlay = withPlayer(withNamespaces()(PlayerOverlayComponent));
